import onErrorImg from 'icons/cardImg.svg';
import { sendButton } from 'icons/send.js';
import './attachmentsPreview.scss';

export const AttachmentPreviewTemplate = (model) => {
	const { placeholder } = model || {};
	/* html */
	const html = `
		<div class="engt-preview-img">
			<img src="" id="attachmentPreviewImg" onerror="this.src='${onErrorImg}'" loader="lazy"/>
			<div class="engt-preview-text" id="attachmentPreviewFileName"></div>
			<div class="engt-upload-error"></div>
		</div>
        <div class="engt-preview-respond">
            <div
	    		role="textbox"
	    		contenteditable
				id="sendAttachmentInputBox"
	    		class="engt-attachment-respondbox"
	    		data-placeholder="${placeholder}"
	    	></div>
            <button
	    		id="sendAttachmentBtn"
	    		class="engt-btn-icons engt-tab-selectable engt-reply-btns"
	    		aria-label="Send Attachment With Message"
	    	>
	    		${sendButton()}
	    	</button>
        </div>
		<div id="attachmentPreviewLoader" class="engt-loader"></div>
    `;

	return html;
};
